import { fontHeadings } from "../../../../enums/font";
import { loadFonts } from "../../../../utils/LoadSiteFonts";
import { IColorOverride } from "../../interfaces/IColorOverride";
import { overrideColorsToCssVars } from "../../utils/overrideColorsToCssVars";
import styles from "./HandDrawnHeart.module.scss";

export interface IProps {
    eventLogo: IEventLogoHandDrawnHeart;
    type: "SITE" | "PRINT";
    cssVarsOnly: string;
}

export interface IPropsDemo {
    type: "DEMO";
    cssVarsOnly: string;
}

export interface IEventLogoHandDrawnHeart {
    name: "HandDrawnHeart";
    name1: string;
    name2: string;
    colorText: IColorOverride;
}

export const HandDrawnHeart = (props: IProps | IPropsDemo) => {
    const eventLogo: Omit<IEventLogoHandDrawnHeart, "name"> =
        props.type !== "DEMO"
            ? props.eventLogo
            : {
                  name1: "Vincent",
                  name2: "Gustaf",
                  colorText: { override: false, color: null },
              };

    const fontFamilyInitials = fontHeadings[4];
    const fontSizeInitials = 200;

    const letterDistance = [22, 0];

    const fontOffsetY = -3;

    const letterPosition = [
        [50 - letterDistance[0], 50 + fontOffsetY - letterDistance[1]],
        [50 + letterDistance[0], 50 + fontOffsetY + letterDistance[1]],
    ];

    loadFonts([{ font: fontFamilyInitials, type: "ONLY_700" }]);

    // Bought from etsy, commercial use allowed
    // https://www.etsy.com/se-en/listing/919101932/heart-initials-svg-love-svg-commercial?ls=r&ref=hp_rv-3&content_source=de8794e4f82cd80c809dc183fc88b320b71adae1%253A919101932&logging_key=de8794e4f82cd80c809dc183fc88b320b71adae1%3A919101932
    return (
        <div
            className={`${styles.wrapper} ${styles[props.type]} ${props.cssVarsOnly}`}
            style={overrideColorsToCssVars([
                { name: "text", colorOverride: eventLogo.colorText }
            ])}
        >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 528.485 639.9" className={styles.svg}>
                {/* Hand-drawn heart shape */}

                <path d="M 257.032 128.815 C 274.258 92.732 301.189 47.362 337.617 21.409 C 363.26 3.137 393.516 -5.707 428.352 3.969 C 470.56 15.73 496.007 38.963 510.717 68.086 C 525.852 98.038 529.433 134.384 528.287 170.893 C 527.08 207.843 510.299 255.536 487.631 304.073 C 481.831 316.485 475.646 328.952 469.299 341.333 C 441.066 396.363 408.773 449.324 386.576 484.861 C 378.105 498.443 362.795 518.577 345.96 539.475 C 321.902 569.342 294.721 600.788 280.146 616.695 C 266.711 631.355 258.003 637.731 251.637 639.335 C 246.444 640.643 242.127 639.626 237.932 636.842 C 234.58 634.623 231.248 630.919 227.276 626.25 C 212.04 608.011 183.649 570.822 156.206 533.7 C 127.015 494.213 98.902 454.801 88.853 438.267 C 81.408 426.077 74.113 413.262 66.978 400.026 C 39.834 349.668 15.925 292.63 5.456 234.971 C 3.679 225.185 2.279 215.383 1.372 205.596 C -2.36 165.316 1.327 125.429 14.801 88.189 C 31.005 41.13 72.614 20.667 116.429 21.225 C 158.878 21.767 203.292 42.269 228.18 77.165 C 234.318 85.774 239.976 94.684 245.062 103.906 C 249.506 111.972 253.505 120.278 257.032 128.815 Z M 237.642 617.494 C 222.325 599.537 193.728 562.905 166.103 526.306 C 136.785 487.462 108.556 448.667 98.442 432.375 C 91.044 420.401 83.69 407.866 76.697 394.803 C 50.282 345.453 28.174 289.149 18.188 232.688 C 16.515 223.229 15.192 213.763 14.193 204.322 C 10.114 165.76 12.253 127.496 24.3 91.496 C 39.162 49.278 76.852 31.345 116.249 32.133 C 155.19 32.912 195.905 51.824 218.493 84.015 C 224.307 92.294 229.635 100.865 234.444 109.714 C 239.239 118.542 243.516 127.65 247.164 137.051 C 247.326 137.46 248.877 142.884 249.869 144.836 C 251.629 148.305 254.637 148.82 255.838 148.825 C 258.05 148.834 260.37 147.877 262.306 145.689 C 264.518 143.193 266.366 137.848 267.068 136.366 C 283.579 101.708 309.512 57.039 345.063 31.904 C 367.657 15.931 394.224 8.044 424.804 16.646 C 462.682 27.271 485.519 48.026 498.819 74.124 C 513.124 102.196 516.625 136.271 515.856 170.558 C 515.107 206.252 499.285 252.471 477.796 299.53 C 472.164 311.858 466.155 324.245 459.862 336.491 C 431.771 391.186 398.992 443.454 376.687 478.638 C 368.29 491.869 353.128 511.447 336.476 531.768 C 312.364 561.197 285.123 592.151 270.527 607.805 C 259.783 619.329 253.483 625.116 248.425 626.342 C 246.786 626.741 245.599 625.91 244.291 624.784 C 242.208 622.994 240.124 620.453 237.642 617.494 Z"></path>
                {/* Plus sign */}
                <path d="M 248.615 296.388 C 248.945 278.174 248.838 260.27 247.529 248.252 C 247.185 245.125 249.444 242.309 252.574 241.968 C 255.704 241.627 258.516 243.888 258.86 247.015 C 260.182 259.158 260.31 277.231 259.993 295.639 C 274.662 294.816 285.636 294.823 303.118 294.859 C 306.268 294.866 308.81 297.425 308.804 300.57 C 308.804 303.715 306.241 306.264 303.098 306.257 C 285.528 306.221 274.642 306.21 259.744 307.07 C 259.231 327.12 258.375 346.177 258.173 356.887 C 258.112 360.032 255.509 362.536 252.359 362.476 C 249.216 362.415 246.714 359.813 246.774 356.668 C 246.976 346.157 247.826 327.501 248.352 307.838 L 247.846 307.876 C 232.59 309.043 217.32 308.904 204.775 307.836 C 201.639 307.569 199.312 304.808 199.575 301.674 C 199.845 298.54 202.603 296.212 205.74 296.479 C 217.752 297.501 232.374 297.628 246.977 296.511 C 247.529 296.47 248.076 296.428 248.615 296.388 Z"></path>
                <text
                    fontFamily={fontFamilyInitials}
                    x={letterPosition[0][0] + "%"}
                    y={letterPosition[0][1] + "%"}
                    textAnchor="middle"
                    dominantBaseline="middle"
                    fontSize={fontSizeInitials}
                    fontWeight={700}
                >
                    {eventLogo.name1.slice(0, 1).toLocaleUpperCase()}
                </text>

                <text
                    fontFamily={fontFamilyInitials}
                    x={letterPosition[1][0] + "%"}
                    y={letterPosition[1][1] + "%"}
                    textAnchor="middle"
                    dominantBaseline="middle"
                    fontSize={fontSizeInitials}
                    fontWeight={700}
                >
                    {eventLogo.name2.slice(0, 1).toLocaleUpperCase()}
                </text>
            </svg>
        </div>
    );
};
